import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLike = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M16.4683 5.47723C17.57 5.48088 18.6261 5.92506 19.4167 6.72091C21.0419 8.35682 21.0331 11.0009 19.3973 12.582L18.911 13.0651L11.7484 20.1805L4.63296 13.0179L4.19388 12.5317C2.56877 10.8958 2.57751 8.25167 4.21327 6.67061C5.00912 5.88001 6.06822 5.44282 7.16992 5.44647C8.27163 5.45011 9.3278 5.8943 10.1184 6.69015L10.6017 7.13243L11.8317 8.32635L13.0695 7.14059L13.5557 6.70152C14.3075 5.91077 15.3225 5.47344 16.4683 5.47723ZM16.4742 3.71451C14.9758 3.70955 13.4316 4.27734 12.2819 5.41931L11.7958 5.85839L11.3125 5.4161C10.1705 4.26655 8.63 3.68856 7.13168 3.6836C5.63338 3.67864 4.13316 4.24657 2.93953 5.3884C0.640409 7.67236 0.62787 11.4622 2.91183 13.7613L3.39497 14.2477L11.1253 22.0293C11.301 22.2062 11.521 22.295 11.7414 22.2957C11.9617 22.2965 12.1824 22.2091 12.3592 22.0334L20.1409 14.3031L20.6272 13.82C22.9264 11.536 22.9389 7.74614 20.6549 5.44701C19.4689 4.29731 17.9724 3.71947 16.4742 3.71451Z" })]
});
const ForwardRef = forwardRef(SvgLike);
export { ForwardRef as ReactComponent };
